import { Group } from '@mantine/core';
import { Text } from '@repo/foundations';
import { ActivityLogPerformerIcon } from '../../ActivityLogPerformer/ActivityLogPerformerIcon';
import type { IActivityLogPerformer } from '../../ActivityLogPerformer/types';

export interface VersionHistoryButtonItemProps {
	performer: IActivityLogPerformer;
}

export function VersionHistoryButtonItem({
	performer,
}: VersionHistoryButtonItemProps) {
	return (
		<Group spacing="2xs" noWrap>
			<ActivityLogPerformerIcon performer={performer} />
			<Text size="sm" color="text/secondary/default">
				{performer.metadata.display_name ??
					performer.metadata.name ??
					'Unknown'}
			</Text>
		</Group>
	);
}
